<template>
  <div class="c-table">
    <div :style="{backgroundColor: colorList[deep]}" style="color:white;display:inline-flex;">
      <div class="cell" style="width: 200px;font-weight: bold;">字段</div>
      <div class="cell" style="width: 120px;font-weight: bold;">类型</div>
      <div v-if="showRequire" class="cell" style="width: 60px;font-weight: bold;">必填</div>
      <div class="cell" style="width: 380px;;font-weight: bold;justify-content: flex-start">描述</div>
    </div>
    <div v-for="(row, index) in data" :key="row.id">
      <div style="display:inline-flex;" class="table-row" :class="{'table-row-striped': index % 2 !== 0}">
        <div v-if="row.referModelDetail" style="width: 200px;cursor: pointer" @click="toggleRow(row)" class="cell">
          <div>
            <div style="position: relative">
              <div style="position: absolute;left:-30px">
                <i class="el-icon-arrow-down arrow" :class="{'rotate': row.hideChild}"></i>
              </div>
            </div>
            <span>{{row.name}}</span>
          </div>
        </div>
        <div v-else class="cell" style="width: 200px">{{row.name}}</div>
        <div class="cell" style="width: 120px">{{typeList.find(typeItem => typeItem.value === row.type).name}}</div>
        <div v-if="showRequire" class="cell" style="width: 60px">
          <span v-if="row.required">是</span>
          <span v-else>否</span>
        </div>
        <div class="cell" style="width: 380px;justify-content: flex-start"><pre>{{row.description}}</pre></div>
      </div>
      <transition @before-leave="initHeight" @enter="enter" @leave="leave" @after-enter="initHeight2">
      <div v-show="row.referModelDetail&&!row.hideChild" style="padding-left: 40px;padding-bottom: 20px;border-bottom:1px solid #EBEEF5;">
        <div style="font-weight: bold;padding:10px;">类型定义</div>
        <expandable-table v-if="row.referModelDetail" :data="row.referModelDetail.paramList" :show-require="showRequire" :deep="deep+1"></expandable-table>
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {nextTick} from "vue";

  export default {
    name: 'ExpandableTable',
    components: {},

    props: {
      data: {
        type: Array
      },
      showRequire: {
        type: Boolean,
        default: false
      },
      deep: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        typeList:[
          {name:'String', value:0},
          {name:'Number', value:1},
          {name:'Boolean', value:2},
          {name:'Object', value:3},
          {name:'Array', value:4}
        ],
        colorList:[
          '#3694b3',
          '#49b336',
          '#7236b3',
          '#b39636',
          '#ac440b',
          '#1eecc6',
          '#f328ba',
          '#a5e831'
        ]
      }
    },

    computed: {
    },
    watch: {
    },
    beforeMount() {
    },
    mounted() {
    },

    destroyed() {},

    methods: {
      toggleRow(row){
        row.hideChild = !row.hideChild;
        this.$forceUpdate();
      },
      initHeight(el)  {
        // 初始时不设置高度为 0，保证其自然显示
        el.style.maxHeight = `${el.scrollHeight}px`; // 设置为内容的高度
        el.style.opacity = '1'; // 保证元素显示
      },
      initHeight2(el)  {
        el.style.maxHeight = '';
      },
      enter(el)  {
        const scrollHeight = el.scrollHeight;
        nextTick(()=>{
          const time = Math.round(scrollHeight / 200) / 10;
          el.style.transition = `max-height ${time}s ease-out, opacity ${Math.min(time, 0.5)}s ease-out`;
          el.style.maxHeight = `${scrollHeight}px`; // 动态设置 max-height 为内容的实际高度
          el.style.opacity = '1'; // 显示内容
        })

      },
      leave(el) {
        const time = Math.round(el.scrollHeight / 200) / 10;
        el.style.transition = `max-height ${time}s ease-out, opacity ${Math.min(time, 0.5)}s ease-out`;
        el.style.maxHeight = '0'; // 收起时 max-height 为 0
        el.style.opacity = '0'; // 隐藏时透明度为 0
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.c-table{
  border-top:1px solid #EBEEF5;
  border-left:1px solid #EBEEF5;
}
.table-row{
  transition: background-color 0.3s;
}
.table-row:hover{
  background-color: #e3e3e3;
  transition: background-color 0.3s;
}
.table-row-striped{
  background-color: #fafafa;
}
.cell{
  display: flex;
  justify-content: center;
  border-right:1px solid #EBEEF5;
  border-bottom:1px solid #EBEEF5;
  padding:12px 10px;
  font-size: 15px;
}
pre {
  white-space: pre-wrap; /* 允许换行 */
  word-wrap: break-word; /* 让长单词换行 */
  width: 100%; /* 限制宽度，可根据需求调整 */
}
.arrow {
  transition: transform 0.3s ease;
}

.arrow.rotate {
  transform: rotate(-90deg);
}
</style>
